import { useSelector } from 'react-redux';

import { processSelector } from '../store/redux-slices/processes/selectors';

export function useProcessing(name: string | string[]) {
  const isProcessing = useSelector(processSelector(name));

  return isProcessing;
}
